<main class="main-dashboard">
    <article class="main-canvas">
        <section class="canvas-container">
            <section class="dashboard-items">
                <div class="canvas-item">
                    <div class="canvas-header row justify-content-between align-items-center">
                        <div class="title col-sm-6">
                            <h3>Goal Profile</h3>
                        </div>
                    </div>
                    <div class="container">
                        <div class="row">
                            <div class="col-sm-3">
                                <div class="box">
                                    <button type="button" title="my performance" class="btn btn-sm" (click)="myperformance()">
                                        <i class="ri-star-line"></i>
                                        <div>My Performance</div>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="this.isHRAdmin">
                            <div class="canvas-header row justify-content-between align-items-center">
                                <div class="title col-sm-6">
                                    <h3>Performance Page for Hr</h3>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-3">
                                    <div class="box">
                                        <button type="button" title="Over All Performance" class="btn btn-sm" (click)="OverallPerformance()" >
                                            <i class="ri-user-line"></i>
                                            <div>Over All Performance</div>
                                        </button>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="box">
                                        <button type="button" title="Skill Matrix" class="btn btn-sm" (click)="OpenSkillMatrix()" >
                                            <i class="ri-user-line"></i>
                                            <div>Skill Matrix</div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>   
                    </div>
                </div>
            </section>
        </section>
    </article>
</main>
